module.exports = __webpack_public_path__ + "static/media/jusa.335bb15b.jpg";